<template>
    <div
        class="
        bg-[#E5E5E5] border-[#D1D1D1]
        fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 
        w-3/4 [@media(min-width:768px)]:w-1/3 h-3/4 bg-white rounded-2xl shadow-xl flex flex-col rounded-[30px]
        flex-grow flex items-center justify-center text-center text-lg font-semibold text-[#000000] px-[30px]">
        <img
          src="@/assets/loading_dots.gif"
          alt="Loading"
        />    
    </div>
</template>